<div class="filters__field">
  @if (organizationEntries().length > 0) {
    <fdr-past-performance-ui-searchable-dropdown
      [label]="'PD.LABELS.ORGANIZATION' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [exclusiveSelection]="true"
      [closesOnSelection]="true"
      [entries]="organizationEntries()"
      [customDsyListConfObject]="dropdownListConfig"
    ></fdr-past-performance-ui-searchable-dropdown>
  } @else {
    <dsy-input-dropdown
      [label]="'PD.LABELS.ORGANIZATION' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [isDisabled]="true"
      [entries]="[]"
    ></dsy-input-dropdown>
  }
</div>
<div class="filters__field">
  @if (hasSelectedOrganization() && sitesEntries().length > 0) {
    <fdr-past-performance-ui-searchable-dropdown
      [label]="'PD.LABELS.SITES' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [closesOnSelection]="false"
      [entries]="sitesEntries()"
      [customDsyListConfObject]="dropdownListConfig"
      [renderCounterTag]="showSitesCounterTag()"
      [counterTagConfig]="counterTagConfig"
    ></fdr-past-performance-ui-searchable-dropdown>
  } @else {
    <dsy-input-dropdown
      [label]="'PD.LABELS.SITES' | translate"
      [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
      [isDisabled]="true"
      [entries]="[]"
    ></dsy-input-dropdown>
  }
</div>
<fdr-past-performance-ui-date-picker
  [datesOptions]="datesOptions"
  [initialDateOption]="store.orgDateOption()"
  [initialDateRange]="store.orgDateRange()"
  [resetTrigger]="dateResetToken()"
  (dateChange)="onDateChange($event)"
  (suggestionChange)="onSuggestionChange($event)"
  (validityChange)="onDateValidityChange($event)"
></fdr-past-performance-ui-date-picker>
